import React, { useContext } from 'react';
import styled from 'styled-components';
import { Link, Location, WindowLocation, navigate } from '@reach/router';
import { useDispatch } from 'react-redux';
import { logoutUser } from 'state/user/UserActions';
import NavContainer from './NavContainer';
import NavLogo from './NavLogo';
import AdminNav from './AdminNav';
import { RFC } from 'state/StateTypes';
import { AdminViewModeContext } from 'state/AdminViewModeContext';
import { UserRole } from 'state/user/UserTypes';

interface Props {
   isAdmin: boolean;
   isUserLoggedIn: boolean;
}

const Nav: RFC<Props> = ({ isAdmin, isUserLoggedIn }) => {
   const { viewingAs, setViewingMode } = useContext(AdminViewModeContext);
   //Location render prop from @reach/router is used because the NavContent was stale and not updating/re-rendering when the pathname changed; this method, albeit hacky, ensures the component stays in sync with window.location.pathname
   return (
      <Location>
         {({ location }) =>
            isAdmin && isUserLoggedIn && viewingAs !== 'customer' ? (
               <AdminNav />
            ) : (
               <NavContainer>
                  {location.pathname !== '/' && <NavLogo />}
                  <PurchaseXen>
                     <a href="https://neuvanalife.com" target="_blank" rel="noopener noreferrer">
                        Purchase Xen
                     </a>
                  </PurchaseXen>
                  <NavContent isUserLoggedIn={isUserLoggedIn} location={location} isAdmin={isAdmin} setViewingMode={setViewingMode} />
               </NavContainer>
            )
         }
      </Location>
   );
};

interface NavContentProps {
   isUserLoggedIn: boolean;
   location: WindowLocation;
   isAdmin: boolean;
   setViewingMode: (role: UserRole) => void;
}

const NavContent: React.FC<NavContentProps> = ({ isUserLoggedIn, location, isAdmin, setViewingMode }): JSX.Element => {
   let Content: JSX.Element,
      dispatch = useDispatch();
   if (isUserLoggedIn) {
      Content = (
         <LogoutUpgradeContainer>
            {isAdmin && (
               <li>
                  <ViewAsAdmin
                     onClick={() => {
                        setViewingMode('admin');
                        navigate('/waveforms');
                     }}>
                     View as admin
                  </ViewAsAdmin>
               </li>
            )}
            <li>
               <Logout to="/" onClick={() => dispatch(logoutUser())}>
                  Logout
               </Logout>
            </li>
         </LogoutUpgradeContainer>
      );
   } else {
      Content = !location.pathname.includes('signup') ? <Link to="/signup">Create Account</Link> : <PlaceHolder />;
   }
   return Content;
};

export default Nav;

//this is a hack to center the Purchase Xen link, Anthony I could use your help with this
const PurchaseXen = styled.div``;

//intended to push purchase xen link to center when create account link not visible
const PlaceHolder = styled.div`
   border: 1px solid red;
   margin-left: 10em;
`;

const Logout = styled(Link).attrs({ role: 'button' })``;

const LogoutUpgradeContainer = styled.ul`
   li {
      list-style-type: none;
      display: inline;
      &:not(:first-child):before {
         content: ' | ';
         color: ${({ theme }) => theme.primaryBlueLight};
         font-size: 1.1em;
      }
   }
`;

const ViewAsAdmin = styled.span`
   cursor: pointer;
`;
